import { baseState, baseMutations } from '@/store/mixins'
import creditTransfer from '@/api/credit-transfer'
import level from '@/api/level'
import SubProgram from '@/api/sub-program'
import Year from '@/api/academic-year'
import Term from '@/api/term-semester'
import MainProgram from '@/api/main-program'
import StudyTime from '@/api/study-time'

export const state = {
  ...baseState,
  academic_years: ['YEAR I', 'YEAR II', 'YEAR III', 'YEAR IV'],
  academic_terms: ['SEMESTER I', 'SEMESTER II'],
  degrees: ['Bachelor', 'Associate', 'Master'],
  direction: 'ASC',
  edit_data: {},
  studyTimes: [],
  itemLists: [],
  main_programs: [],
}
export const getters = {}
export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STUDY_TIMES(state, data) {
    state.studyTimes = data
  },
  SET_ITEM_LISTS(state, data) {
    state.itemLists = data
  },
  SET_MAIN_PROGRAMS(state, data) {
    state.main_programs = data
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true,

      },
      attrubutes
    )
    return creditTransfer.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  getLevel(context, attributes = {}) {
    return level.get({
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      },
      params: {
        page: -1,
        fields: {
          academic_program_levels:
            'level_id,level_name_foreign,level_name_native'
        },
        ...attributes
      }
    })
  },
  getSubProgram(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getYear(context, attributes = {}) {
    return Year.get({
      params: Object.assign(
        {
          fields: {
            academic_years: 'ac_year_id,ac_year,ac_status_id'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTerm(context, attributes = {}) {
    return Term.get({
      params: Object.assign(
        {
          fields: {
            academic_terms: 'ac_term_id,term_name,ac_status_id,term_order'
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubject(context, attrubutes = {}) {
    return creditTransfer.getSubject(attrubutes)
  },
  store(context, data) {
    return creditTransfer.store(data)
  },
  delete(context, id) {
    return creditTransfer.deleteItem(id)
  },
  printPdf(context, id) {
    return creditTransfer.printPdf(id)
  },
  attachFile(context, data) {
    return creditTransfer.attachFile(data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await creditTransfer.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  uploadLogo(context, data) {
    return creditTransfer.uploadfile(data)
  },
  fetchNationality(context) {
    return creditTransfer.nationality()
  },

  fetchReligion(context) {
    return creditTransfer.religion()
  },
  getSubProgramByMain(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          filter: {
            acp_id: attributes.acp_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getMainProgram(context, attributes = {}) {
    return MainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    }).then(response => {
      context.commit('SET_MAIN_PROGRAMS', response.data)
      return Promise.resolve(response)
    })
  },
  getSubProgramByMain(context, attributes = {}) {
    return SubProgram.get({
      params: Object.assign(
        {
          fields: {
            academic_program_subs: 'acps_id,acps_name_foreign'
          },
          filter: {
            acp_id: attributes.acp_id
          },
          page: -1
        },
        attributes
      ),
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getAcYear(context, attributes = {}) {
    return Year
      .get({
        params: Object.assign(
          {
            fields: {
              academic_years: 'ac_year_id,ac_year,ac_status_id'
            },
            page: -1
          },
          attributes
        ),
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_AC_YEARS', response.data)
        return Promise.resolve(response)
      })
  },
  fetchStudyTime(context, attributes = {}) {
    let params = {
      page: -1,
      fields: {
        academic_study_times: 'ac_st_id,study_time,session'
      },
      ...attributes
    }

    return StudyTime.get({ params }).then(response => {
      context.commit('SET_STUDY_TIMES', response.data)
      return Promise.resolve(response)
    })
  },
  async dataForSchoolInformation(context) {
    if (!context.state.itemLists.length > 0) {
      let response = await creditTransfer.itemList()
      context.commit('SET_ITEM_LISTS', response.data)
    }

  },
  async uploadPhoto(context, data) {
    return creditTransfer.uploadPhoto(data)
  },
  storeStudentProfile(context, data) {
    return creditTransfer.storeStudentProfile(data)
  }
}